/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { Collapse, Form } from 'react-bootstrap';
import DataTableFilter from "../../Common/DataTableFilter";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import { ClearFormSetFutios } from "../../../redux/actions/adminActions";
import CommonTable from "../../Common/CommonTable";
import CommonReactSelectMenu from "../../Common/CommonReactSelectMenu";

const FranchiseReports = (props) => {
    const Dispatch = useDispatch();
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("all");
    const [ ParentChildFilter, setParentChildFilter ] = useState(false);
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ selectState, setSelectState ] = useState("");
    const [ selectCity, setSelectCity ] = useState("");
    const [ FilterOpen, setFilterOpen ] = useState(false);
    const { FranchiseReportList, device_id, selfInfo, citylistall, statelistall, sortingfor } = useSelector((state) => state.adminReducers);
    const optionsState = statelistall?.filter((elm) => elm?.is_active === true)?.map((item, index) => ({ ...item, key: item.id, value: item?.id, label: item?.state_name }));
    const optionsCity = citylistall?.filter((elm) => elm?.is_active === true)?.map((item, index) => ({ ...item, key: item.id, value: item?.id, label: item?.district_name }));
    const { websocket } = useContext(WebSocketContext);
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    // select user type
    const SelectFranchiseUserTypeFnct = (e) => {
        setParentChildFilter(e.target.value);
        setCurrentPage(1);
    };

    // update state wise city 
    const optionCityMemo = useMemo(() => {
        return optionsCity?.filter((elm) => {
            if(selectState === "") {
                return elm;
            } else {
                if(elm?.state_id === selectState?.value) {
                    return elm;
                } else {
                    elm
                };
            }
        })
    }, [ selectState ]);

    // get all state
    useEffect(() => {
        let param = { 
            "transmit": "broadcast", 
            "url": "state_list",
            "request" : { 
                "status" : "", 
                "limit" : 5000,
                "page_no" : 1, 
                "search" : ""
            },
            "DeviceId" : device_id
        };
        wsSend_request(websocket, param);
    }, [ websocket ]);

    // get all city list
    useEffect(() => {
        let param = { 
            "transmit": "broadcast", 
            "url": "district_list",
            "request" : { 
                "status" : "", 
                "limit" : 5000,
                "page_no" : 1, 
                "search" : ""
            },
            "DeviceId" : device_id
        };
        wsSend_request(websocket, param);
    }, [ websocket ]);

    // api calling
    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.PaymentManager[8]?.Edit || PermissionsAccess?.PaymentManager[8]?.View)) {
            let ParamUpdate;

            if(ParentChildFilter === "SubDealer") {
                ParamUpdate = { 
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "search" : userSearch.trim(),
                    "state_id" : selectState?.value,
                    "city_id" : selectCity?.value,
                    "order_by": sortingfor,
                    "is_child" : true,
                    "is_oms": true
                }
            } else if(ParentChildFilter === "Dealer") {
                ParamUpdate = { 
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "search" : userSearch.trim(),
                    "state_id" : selectState?.value,
                    "city_id" : selectCity?.value,
                    "order_by": sortingfor,
                    "is_parent" : true,
                    "is_oms": true
                }
            } else {
                ParamUpdate = { 
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "state_id" : selectState?.value,
                    "city_id" : selectCity?.value,
                    "order_by": sortingfor,
                    "search" : userSearch.trim(),
                    "is_oms": true
                }
            };

            let param = { 
                "transmit": "broadcast", 
                "url": "franchise_list",
                "request" : ParamUpdate,
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    };

    // when page load api calling
    useEffect(() => {
        APICall();
    }, [ websocket, userSearch, userType, currentPage, userLimit, ParentChildFilter, selectState, selectCity ]);

    useEffect(() => {
        if (sortingfor !== "" && sortingfor !== "-") { 
            APICall();
        };
    }, [ sortingfor ]);

    useEffect(() => {
        Dispatch(ClearFormSetFutios({
            url:"",
            action:false
        }));
    }, []);

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'customer_name', label: 'Name', type: "label", sort: "customer_name", isCollapsable: false },
        { key: 'franchise_code', label: 'Franchise Code', type: "label_franchise_code", sort: "franchise_code", isCollapsable: false },
        { key: 'erp_code', label: 'ERP ID', type: "label_check_none_empty", sort: "", isCollapsable: false },
        { key: 'erp_address_code', label: 'ERP Address ID', type: "label_check_none_empty", sort: "", isCollapsable: false },
        { key: 'credit_limit', label: 'Credit limit', type: "label_check_none_number", sort: "", isCollapsable: false },
        { key: 'outstanding', label: 'Outstanding', type: "label_check_none_number", sort: "", isCollapsable: false },
        { key: '', label: 'Available Balance', type: "available_balance_label", sort: "", isCollapsable: false },
    ];

    return(<section className="Main_section" id="FranchiseReports">
        <DataTableFilter 
            searchType={"Name, Franchise Code"}
            filterType={"Franchise Report"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={false}
            searchdisable={true}
            ActiveInactiveFilter={true}
            ParentChildFilter={ParentChildFilter}
            SelectFranchiseUserTypeFnct={SelectFranchiseUserTypeFnct}
            FilterOpen={FilterOpen}
            setFilterOpen={setFilterOpen}
        />
        <Collapse in={FilterOpen}>
            <div className="formloginset">
                <div className="row">
                    <div className="col-md-3">
                        <Form.Group className="mb-3">
                            <CommonReactSelectMenu 
                                label={"State"}
                                options={optionsState} 
                                selectValue={selectState} 
                                setSelectValue={setSelectState} 
                                dependantState={{
                                    allow: true,
                                    statType: "current_page",
                                    stateFunction: setCurrentPage
                                }} 
                                isMendatory={false}
                                isAllowClearable={true}
                                customWidth={"100%"}
                                customeHeight={"38px"}
                                isMulti={false}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-md-3">
                        <Form.Group className="mb-3">
                            <CommonReactSelectMenu 
                                label={"City"}
                                options={optionCityMemo}
                                selectValue={selectCity} 
                                setSelectValue={setSelectCity} 
                                dependantState={{
                                    allow: true,
                                    statType: "current_page",
                                    stateFunction: setCurrentPage
                                }} 
                                isMendatory={false}
                                isAllowClearable={true}
                                customWidth={"100%"}
                                customeHeight={"38px"}
                                isMulti={false}
                            />
                        </Form.Group>
                    </div>
                </div>
            </div>
        </Collapse>
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{ height: FilterOpen === true ? parseInt(FranchiseReportList?.pagination?.total_records) === FranchiseReportList?.list?.length ? "calc(100vh - 195px)" : FranchiseReportList?.pagination?.total_records > 10 ? "calc(100vh - 231px)" : "calc(100vh - 195px)" : parseInt(FranchiseReportList?.pagination?.total_records) === FranchiseReportList?.list?.length ? "calc(100vh - 155px)" : FranchiseReportList?.pagination?.total_records > 10 ? "calc(100vh - 178px)" : "calc(100vh - 142px)"}} 
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={"FranchiseReportsData"} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={FranchiseReportList} // CATEGORY LIST
            Pagination={FranchiseReportList?.pagination} // CURRENT TAB PAGINATION
            EditAccess={false} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: false,
                label: "",
                naviagte: ``
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default FranchiseReports;